import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// 订单数量状态管理
interface State {
  landerInvoiceCount: number
  supplierInvoiceCount: number
  setLanderInvoiceCount: (count: number) => void
  setSupplierInvoiceCount: (count: number) => void
}

export const useInvoiceEntryStore = create<State>()(
  devtools((set) => ({
    landerInvoiceCount: 0,
    supplierInvoiceCount: 0,
    setLanderInvoiceCount(count) {
      set({
        landerInvoiceCount: count,
      })
    },
    setSupplierInvoiceCount(count) {
      set({
        supplierInvoiceCount: count,
      })
    },
  })),
)import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// 订单数量状态管理
interface State {
  landerInvoiceCount: number
  supplierInvoiceCount: number
  setLanderInvoiceCount: (count: number) => void
  setSupplierInvoiceCount: (count: number) => void
}

export const useInvoiceEntryStore = create<State>()(
  devtools((set) => ({
    landerInvoiceCount: 0,
    supplierInvoiceCount: 0,
    setLanderInvoiceCount(count) {
      set({
        landerInvoiceCount: count,
      })
    },
    setSupplierInvoiceCount(count) {
      set({
        supplierInvoiceCount: count,
      })
    },
  })),
)